import TheMenu from './components/TheMenu.vue';
import router from './router';
import store, { types } from './store';
import { Vue } from './vue';

function initTheMenu() {
  const vueTheMenu = document.getElementById('vue-the-menu');
  // If it is not found, then abort the creation of Vue instance
  // Example: Login page
  if (!vueTheMenu) return;

  const data = JSON.parse(vueTheMenu.dataset.vue);

  // eslint-disable-next-line no-unused-vars
  const vm = new Vue({
    el: '#vue-the-menu',
    data: {
      menu: data.menu,
    },
    render(h) {
      return h(TheMenu, {
        props: {
          menu: this.menu,
        },
      });
    },
    store,
    router,
  });

  $(window).on('beforeunload', () => {
    store.commit(types.productList.hide);
  });
}

export default initTheMenu;
